import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { opApi, apiError } from "@/lib/api";

// Superadmin: permanently delete a shop's MorrCart data. Type the shop address to confirm.
export function DeleteShopDialog({ shop, onClose, onDeleted }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  if (!shop) return null;

  const del = async () => {
    setBusy(true);
    try {
      await opApi.delete(`/admin/tenants/${shop.id}`);
      toast.success(`${shop.name} deleted`);
      onDeleted();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail) || "Couldn't delete this shop.");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-none" data-testid="delete-shop-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Delete {shop.name}?</DialogTitle>
          <DialogDescription>
            This permanently removes the shop and everything MorrCart stores for it: products, orders, customers, loyalty,
            bookings and settings. Its business in Morr Access is not touched. If someone opens MorrCart for that business
            again, a new empty shop is created.
          </DialogDescription>
        </DialogHeader>
        <div className="text-sm">Type <span className="font-mono font-bold">{shop.slug}</span> to confirm.</div>
        <Input className="rounded-none" value={typed} onChange={(e) => setTyped(e.target.value)} data-testid="delete-shop-confirm-input" />
        <DialogFooter>
          <Button variant="outline" className="rounded-none" onClick={onClose} data-testid="delete-shop-cancel">Cancel</Button>
          <Button variant="destructive" className="rounded-none gap-2" disabled={busy || typed !== shop.slug} onClick={del} data-testid="delete-shop-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} Delete shop
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
